(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lamed-content-groups"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      var list = root.querySelector('[data-lcg-tablist]');
      if (!list) { return; }
      var tabs = [].slice.call(root.querySelectorAll('[data-lcg-tab]'));
      var panels = [].slice.call(root.querySelectorAll('[data-lcg-panel]'));
      if (!tabs.length) { return; }

      function select(index) {
        for (var i = 0; i < tabs.length; i++) {
          var on = i === index;
          tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
          tabs[i].tabIndex = on ? 0 : -1;
          if (panels[i]) { panels[i].hidden = !on; }
        }
      }

      for (var i = 0; i < tabs.length; i++) {
        (function (index) {
          tabs[index].addEventListener('click', function () { select(index); });
          tabs[index].addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight') { next = (index + 1) % tabs.length; }
            else if (e.key === 'ArrowLeft') { next = (index - 1 + tabs.length) % tabs.length; }
            else if (e.key === 'Home') { next = 0; }
            else if (e.key === 'End') { next = tabs.length - 1; }
            if (next === null) { return; }
            e.preventDefault();
            select(next);
            tabs[next].focus();
          });
        })(i);
      }
    }

    function initAccordion(root) {
      var rows = [].slice.call(root.querySelectorAll('[data-lcg-row]'));
      if (rows.length < 2) { return; }
      for (var i = 0; i < rows.length; i++) {
        (function (row) {
          row.addEventListener('toggle', function () {
            if (!row.open) { return; }
            for (var j = 0; j < rows.length; j++) {
              if (rows[j] !== row) { rows[j].open = false; }
            }
          });
        })(rows[i]);
      }
    }

    function init() {
      var roots = document.querySelectorAll('[data-lcg]');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].getAttribute('data-lcg-ready') === '1') { continue; }
        roots[i].setAttribute('data-lcg-ready', '1');
        initTabs(roots[i]);
        initAccordion(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamed-static-hero"] && !Shopify.designMode) return;
  try {
    
  const setupLamedReviewCarousel = () => {
    const section = document.querySelector('[id$="__1772478267c1f373bd"]');
    const widget = section?.querySelector('.jdgm-cards-carousel');

    if (!section || !widget) return;

    const removeReviewLinks = () => {
      section.querySelectorAll('.jdgm-product-name a').forEach((link) => {
        if (link.hasAttribute('href')) link.removeAttribute('href');
        if (link.hasAttribute('target')) link.removeAttribute('target');
        if (link.getAttribute('tabindex') !== '-1') link.setAttribute('tabindex', '-1');
      });
    };

    removeReviewLinks();

    if (widget.dataset.lamedReviewReady === 'true') return;
    widget.dataset.lamedReviewReady = 'true';

    const observer = new MutationObserver(removeReviewLinks);
    observer.observe(widget, { childList: true, subtree: true });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let paused = false;
    const stop = () => { paused = true; };
    const start = () => { paused = false; };

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);

    const timer = window.setInterval(() => {
      if (!section.isConnected) {
        window.clearInterval(timer);
        observer.disconnect();
        return;
      }

      if (paused || document.hidden) return;
      section.querySelector('button[aria-label="Next slide"]')?.click();
    }, 5000);
  };

  const setupLamedHomepageAnchors = () => {
    const routines = document.querySelector('[id$="__collection_list_A6rxWN"]');
    if (routines) routines.setAttribute('data-navigation-anchor', 'ready-made-routines');

    document.querySelectorAll('header a[href*="/collections/complete-acne-routine"]').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'routines') {
        link.setAttribute('href', '/#ready-made-routines');
      }
    });

    if (!document.getElementById('ready-made-routines') && routines) {
      const anchor = document.createElement('span');
      anchor.id = 'ready-made-routines';
      anchor.setAttribute('aria-hidden', 'true');
      anchor.style.cssText = 'position:absolute;inset-block-start:-110px;';
      routines.style.position = 'relative';
      routines.prepend(anchor);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupLamedReviewCarousel();
      setupLamedHomepageAnchors();
    }, { once: true });
  } else {
    setupLamedReviewCarousel();
    setupLamedHomepageAnchors();
  }

  document.addEventListener('shopify:section:load', setupLamedReviewCarousel);
  document.addEventListener('shopify:section:load', setupLamedHomepageAnchors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
